import { render, staticRenderFns } from "./tradeupload-list.vue?vue&type=template&id=3af616e5&"
import script from "./tradeupload-list.vue?vue&type=script&lang=js&"
export * from "./tradeupload-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeupload-list.vue"
export default component.exports